import React, { Fragment, useState, useEffect } from 'react';
import man from '../../../assets/images/user/user.png';
import { User, Mail, Lock, Settings, LogOut } from 'react-feather';
import app from "../../../data/base";
import request, { socket_chat, NodeURL, socket } from "../../../api/api";
import { Link } from 'react-router-dom';
import { withRouter } from 'react-router';
import jwt_decode from "jwt-decode";
import { ToastContainer, toast } from "react-toastify";


const UserMenu = ({ history, show_hide }) => {
    const [profile, setProfile] = useState('');
    const [avatar, setAvatar] = useState('');
    const [name, setName] = useState('');
    const [fname, setFName] = useState('');
    const [lname, setLName] = useState('');
    const [email, setEmail] = useState('');
    const sty_le = { 'font-size': '15px' };

    let get_profile =async () => {
        request({
            url: "/employee/profile",
            method: "POST",
        }).then((res) => {
            if (res && +res.status === 1) {
                let data = res.response.result || {};
                setFName(data.name && data.name.length > 0 && String(data.name) !== String(undefined) ? data.name : '');
                setLName(data.surname && data.surname.length > 0 && String(data.surname) !== String(undefined) ? data.surname : '');
                setEmail(data.email && data.email.length > 0 && String(data.email) !== String(undefined) ? data.email : '');
                let profileImg =  data && data.onlineform && data.onlineform.UploadIDPhoto;
                localStorage.setItem('avatar',profileImg)
                setAvatar(profileImg)
            }
        }).catch((err) => {
            console.log("err in /employee/profile", err)
        })
    }

    useEffect(() => {
        get_profile();
        const tokenAgency = localStorage.getItem("APUSEC");
        if (tokenAgency) {
            let token = jwt_decode(tokenAgency);
            if (token && token.name) {
                setName(token.name);
            }
        }
        setProfile(localStorage.getItem('profileURL') === null ? man : localStorage.getItem('profileURL'));
        setAvatar(localStorage.getItem('avatar') === undefined ? man : localStorage.getItem('avatar'));
    }, []);

    socket.on('Updated_avatar', (data) => {
        const tokenAgency = localStorage.getItem("APUSEC");
        if (tokenAgency) {
            let token = jwt_decode(tokenAgency);
            if (token && token.user_id && data && data._id) {
                if (String(token.user_id) === String(data._id)) {
                    if (data.avatar && String(data.avatar).length > 0) {
                        setAvatar(data.avatar);
                        localStorage.setItem('avatar', data.avatar);
                    }
                }
            }
        }
    });

    const logOut = (e) => {
        const tokenAgency = localStorage.getItem("APUSEC");
        if (tokenAgency) {
            let token = jwt_decode(tokenAgency);
            if (token && token.user_id) {
                socket_chat.emit('Update_offline_user_id', ({ user: token.user_id }));
                // socket_chat.emit('disconnect', ({ user: token.user_id }));
            }
        }
        localStorage.removeItem('profileURL');
        localStorage.removeItem('avatar');
        localStorage.removeItem('APUSEC');
        localStorage.removeItem('isAuthenticated');
        localStorage.removeItem('first_time');
        localStorage.removeItem('layout_versioncan');
        localStorage.removeItem('colorcan');
        localStorage.removeItem('primary_colorcan');
        localStorage.removeItem('secondary_colorcan');
        localStorage.removeItem('loginWithFirstTime');
        history.push(`/login`);
        // window.location = "/candidate/login"
    }

    socket.on('upgrade_to_employee', (data) => {
        const tokenAgency = localStorage.getItem("APUSEC");
        if (tokenAgency) {
            let token = jwt_decode(tokenAgency);
            if (token && token.user_id && data && data._id) {
                if (String(token.user_id) === String(data._id)) {
                    toast.info(data.message);
                    socket_chat.emit('Update_offline_user_id', ({ user: token.user_id }));
                    socket_chat.emit('disconnect', ({ user: token.user_id }));
                    localStorage.removeItem('profileURL');
                    localStorage.removeItem('avatar');
                    localStorage.removeItem('APUSEC');
                    localStorage.removeItem('isAuthenticated');
                    localStorage.removeItem('first_time');
                    localStorage.removeItem('layout_versioncan');
                    localStorage.removeItem('colorcan');
                    localStorage.removeItem('primary_colorcan');
                    localStorage.removeItem('secondary_colorcan');
                    let hostname = window.location.hostname, protocol = window.location.protocol, port = window.location.port;
                    if (hostname.includes('localhost')) {
                        toast.info(data.message);
                        window.location.href = `${protocol}//${hostname}:${port}/employee`;
                    } else {
                        toast.info(data.message);
                        window.location.href = `${protocol}//${hostname}/employee`;
                    }
                }
            }
        }
    })

    return (
        <Fragment>
            {/* <li className="onhover-dropdown"> */}
            <ul>
                <li>
                    <div className="media align-items-center">
                        <img className="align-self-center pull-right img-50 rounded-circle blur-up lazyloaded" src={avatar && String(avatar) !== "undefined" ? `${NodeURL}/${avatar}` : profile} alt="header-user" />
                        {/* <div className="dotted-animation">
                            <span className="animate-circle"></span>
                            <span className="main-circle"></span>
                        </div> */}
                    </div>
                    <ul className={`profile-dropdown onhover-show-div ${show_hide === true ? 'active' : history.location && history.location.show_hide === false ? 'active' : ''} p-20 profile-dropdown-hover`}>
                        <li>
                            <span className="drop-profile"><div className="profile-img">
                                {lname && lname.length > 0 && String(lname) !== String(undefined) && fname && fname.length > 0 && String(fname) !== String(undefined) ?
                                    `${String(fname).charAt(0)}${String(lname).charAt(0)}` : fname && fname.length > 0 && String(fname) !== String(undefined) ? `${String(fname).charAt(0)}` :
                                        lname && lname.length > 0 && String(lname) !== String(undefined) ? `${String(lname).charAt(0)}` : null}
                            </div>
                                <span className="drop-user"><span>{`Hello, ${name}`}</span><span className="drop-email">{email}</span></span></span>
                        </li>
                        <li><Link to={`/profile-edit`}> Edit Account</Link></li>
                        {/* <li><a href="#!"><Mail />Inbox</a></li>
                        <li><a href="#!"><Lock />Lock Screen</a></li>
                        <li><a href="#!"><Settings />Settings</a></li> */}
                        <li style={{ cursor: 'pointer' }}><a onClick={logOut} > Log out</a></li>
                    </ul>
                </li>
            </ul>
        </Fragment>
    );
};


export default withRouter(UserMenu);